@if (paletteService.visible()){
  <div class="palette-backdrop" (click)="closePalette()">
    <div class="palette-container" (click)="$event.stopPropagation()">

      <input
        #searchInput
        type="text"
        placeholder="Buscar módulo..."
        (input)="search($any($event.target).value)"
      />

      <div class="results">
        @for (item of results(); track item.label; let i = $index) {
          <button type="button" class="result-item" [class.active]="i === selectedIndex()" (click)="navigate(item)">
            {{ item.label }}
          </button>
        }

      </div>

    </div>
  </div>
}

